import React from 'react';
import style from './profileEditForm.module.css';
import { useForm } from 'react-hook-form';
import ButtonStyleWrapper from '../../../../../../commonComponents/ButtonStyleWrapper/ButtonStyleWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDataThunk } from '../../../../../../../redux/reducers/profile-reducer';

const ProfileEditForm = (props) => {
    const {
        register,
        formState: {
            errors,
            isValid,
        },
        setError,
        clearErrors,
        reset,
        handleSubmit,
    } = useForm({
        mode: 'onChange',
        values: {
            ...props.data,
            lookingForAJob: props.data.lookingForAJob ? 'true' : 'false',
        }
    });

    const userData = useSelector(state => state.profilePage.userInfo);

    const maxLengthObj = {
        maxLength: {
            value: 20,
            message: 'Max length is 20 symbols',
        }
    }

    const dispatch = useDispatch();

    const submitHandler = (data) => {
        const fullData = {
            ...data,
            fullName: userData.fullName,
            userId: userData.userId,
        }
        dispatch(setUserDataThunk({ fullData }))
            .then(response => {
                (response.payload.resultCode === undefined)
                    && props.setEdit(editMode => editMode = false);
            });
    };

    return (
        <form onSubmit={handleSubmit(submitHandler)} className={style.formContainer}>
            <div className={style.lookingBlock}>
                <span>
                    <p>Looking for a job?</p>
                    <div className={style.lookingRadio}>
                        Yes
                        <input value='true' type="radio" {...register('lookingForAJob')} />
                        No
                        <input value='false' type="radio" {...register('lookingForAJob')} />
                    </div>
                </span>
                <span>
                    <p>Comment</p>
                    <textarea placeholder="Looking a job for.." type="text" {...register('lookingForAJobDescription', {
                        required: 'This field is required',
                        ...maxLengthObj,
                    }
                    )} />
                    {errors?.lookingForAJobDescription && <p><i>{errors.lookingForAJobDescription.message}</i></p>}
                </span>
                <span>
                    <p>About me</p>
                    <textarea placeholder='I am..' type="text" {...register('aboutMe', {
                        required: 'This field is required',
                        ...maxLengthObj,
                    }
                    )} />
                    {errors?.aboutMe && <p><i>{errors.aboutMe.message}</i></p>}
                </span>
                {props.data.error && <p><i>{props.data.error}</i></p>}
                <ButtonStyleWrapper>
                    <button>Update data</button>
                </ButtonStyleWrapper>
            </div>
            <div className={style.contacts}>
                {Object.keys(props.data.contacts).map((key, index) => {
                    return (
                        <span key={index}>
                            <p>{key}</p>
                            <input placeholder="https://" type="text" {...register(`contacts.${key}`, {
                                pattern:{
                                    value:/^((http|https):\/\/)([A-z0-9]+)\.[A-z0-9]+/,
                                    message:'Please enter a valid url',
                                },
                            })} />
                            {errors?.contacts?.[key] && <p><i>{errors.contacts[key].message}</i></p>}
                        </span>
                    )
                })}
            </div>
        </form>
    )
};

export default ProfileEditForm;